module.exports = __webpack_public_path__ + "media/images/scoreBet__picker__close-0e19123078f9047f744062bc728b35e8.png";